'use strict';

/* Services */
import dynamicPageService from '../../services/dynamic-page/dynamic-page.service';

/* Directives */
import bindDynamicPageDirective from '../../components/bind-dynamic-page/bind-dynamic-page.directive';

/* Views */
import dynamicPageList from './list/dynamic-page-list.component';
import dynamicPageEdit from './edit/dynamic-page-edit.component';
import dynamicPageView from './view/dynamic-page.component';

/* Module */
export default angular.module('conduu.ap.dynamicPages', [dynamicPageService, bindDynamicPageDirective,
  dynamicPageList, dynamicPageEdit, dynamicPageView])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/dynamic-pages/index.js